import { combineReducers } from 'redux';

import Layout from './layout/reducer';
import EditRestriction from './action-restriction/reducer';
import { PhasingDataSource, PhasingType } from './phasing-data/reducer';
import FilterData from './filter-data/reducer';

const rootReducer = combineReducers({
  Layout,
  EditRestriction,
  PhasingDataSource,
  PhasingType,
  FilterData
});

export default rootReducer;
